import { router } from '@inertiajs/vue3';

const LAST_USER_KEY = 'storage-user-id';
const USER_SCOPED_KEY_PREFIXES = [
    'command-palette:recently-viewed:',
    'vendor-agent-chat:conversations:',
    'vendor-calendar-query:',
];

const removeUserScopedKeys = (storage: Storage) => {
    Object.keys(storage)
        .filter((key) => {
            return USER_SCOPED_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
        })
        .forEach((key) => {
            storage.removeItem(key);
        });
};

export function clearUserScopedStorageOnUserChange(userId: string | null): void {
    try {
        if (window.localStorage.getItem(LAST_USER_KEY) === userId) {
            return;
        }

        removeUserScopedKeys(window.localStorage);
        removeUserScopedKeys(window.sessionStorage);

        if (userId) {
            window.localStorage.setItem(LAST_USER_KEY, userId);
        } else {
            window.localStorage.removeItem(LAST_USER_KEY);
        }
    } catch {
        // Storage may be blocked; never break navigation over it.
    }
}

export function registerUserScopedStorageCleanup(): void {
    router.on('navigate', (event) => {
        clearUserScopedStorageOnUserChange(event.detail.page.props.auth.user?.external_id ?? null);
    });
}
